// \src\App.jsx

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// L'ISCRIZIONE del modello nuovo (RL-4 + RL-5a). I due moduli vecchi
// (`Register.jsx` e `RegisterMulti.jsx`) e le loro rotte /register e
// /register-multi sono stati RIMOSSI da RL-5b: la porta d'iscrizione è una
// sola, /enrol.
import Enrol from './pages/Enrol';
import UsersList from './pages/UsersList';
import TeamAssignment from './pages/TeamAssignment';
import TeamsList, { TeamsListDetail } from './pages/TeamsList';
// MEMBER REMINDERS (Fase 1): solleciti spediti a mano dall'amministratore.
import Reminders from './pages/Reminders';
import UniformDistribution from './pages/UniformDistribution';
// La plancia degli eventi clinic (cantiere CLINICS, Fetta B). ⚠️ È una pagina
// NUOVA e separata: non ha nulla a che vedere con la vecchia sezione clinics
// (`pages/clinics/`, /admin/clinics), il cui codice è stato tolto dalla P3
// (24/9/2026); i suoi dati, nella collezione `clinics`, restano.
import ClinicEvents from './pages/ClinicEvents';
// La pagina di UN evento clinic della plancia (CLINICS, Fetta 3 «plancia a
// pagine»): ciò che fino ad allora si apriva a tendina sotto la riga.
import ClinicEventDetail from './pages/ClinicEventDetail';
// La porta del guest (cantiere CLINICS, Fetta C1): la pagina PUBBLICA del link
// di un evento clinic. Rotta nuda, più sotto accanto a /finish-login.
import ClinicGuestEnrol from './pages/ClinicGuestEnrol';

// L'area CLINIC DEL SOCIO (cantiere CLINICS, Fetta C2): gli eventi aperti e
// l'iscrizione di un proprio figlio minore. È la pagina DEL SOCIO, non la
// plancia: quella è ClinicEvents, qui sopra, ed è ADMIN/SUPERADMIN.
import ClinicMember from './pages/ClinicMember';
// Il calendario clinic di UNA persona (CALENDARIO CLINIC, Fetta 2): ci si
// arriva dal bottone «Calendar» delle righe ENROLLED di /clinics.
import ClinicCalendar from './pages/ClinicCalendar';
import ClinicBoard from './pages/ClinicBoard';
import Home from './pages/Home';
import Login from './pages/Login';
// L'atterraggio del link di accesso ricevuto via email (RL-8b).
import FinishLogin from './pages/FinishLogin';
import { AuthProvider, useAuth } from './context/AuthContext';
import MemberProfileModal from './components/MemberProfileModal';
// La MODIFICA della scheda, pagina gemella della scheda stessa (cantiere
// «Edit Member», fase 1). Vedi il blocco di commento della rotta più sotto.
import EditMemberPage from './pages/EditMemberPage';
import ClubFinance from './components/ClubFinance';
import CalendarClub from './components/CalendarClub';
// IL CALENDARIO DEL SOCIO — pagina NUOVA (doc 07 §13), su rotta propria.
// Convive con CalendarClub, che resta la pagina dell'ADMIN: è uno stato
// TRANSITORIO voluto dal committente, non un doppione dimenticato. Vedi
// il blocco della rotta /my-calendar più sotto.
import MyCalendar from './pages/MyCalendar';
import Messaging from './pages/Messaging';
import Assistant from './pages/Assistant';
import PermissionsManager from './components/PermissionsManager';
import useFCMDeviceToken from './hooks/useFCMDeviceToken';
import Attendance from './pages/Attendance';
import AttendanceSummary from './pages/AttendanceSummary';
// Le presenze degli ALLENATORI, segnate dall'amministratore (cantiere
// COACH-ATTENDANCE, Fetta 2). Pagina ADMIN/SUPERADMIN: vedi la rotta
// /coach-attendance più sotto, accanto a /clinic-events.
import CoachAttendance from './pages/CoachAttendance';
// La SCHEDA di un allenatore (Fetta 3): sola lettura, ADMIN/SUPERADMIN,
// rotta /coach-attendance/coach/:coachId, accanto a /coach-attendance.
import CoachAttendanceDetail from './pages/CoachAttendanceDetail';
// La sezione GAMES del coach (cantiere GAMES, fetta G1): la lista partite
// di una squadra e la preparazione (convocazione) di una partita. Pagine
// NUOVE, con cassetto dati loro (`games`, backend F1). Le pagine del
// vecchio Game Call Ups / Game History sono state tolte (D-147).
import GamesListPage from './pages/GamesListPage';
import GamePreparePage from './pages/GamePreparePage';

// Home nuove (una per ruolo del modello nuovo) + viste di sistema.
import HomeSuperadmin from './pages/home/HomeSuperadmin';
import HomeAdmin from './pages/home/HomeAdmin';
import HomeCoach from './pages/home/HomeCoach';
import HomePlayer from './pages/home/HomePlayer';
import HomeParent from './pages/home/HomeParent';
import HomePending from './pages/home/HomePending';
import HomeIncomplete from './pages/home/HomeIncomplete';
// Home di sola clinic: NON è una home di socio (vedi la rotta, più sotto).
import HomeGuest from './pages/home/HomeGuest';
import HomeContext from "./pages/home/HomeContext";
// Vista delegata del minore: resta sulla rotta vecchia, sarà revisionata
// in un incarico dedicato (diario, MAPPA DELLE HOME).
import HomeChild from "./pages/home/HomeChild";

// Cancello condiviso: l'unico controllo d'accesso del frontend.
import RequireRole from './components/RequireRole';

import Outlook from "./components/Outlook";
import UserContextManager from "./pages/UserContextManager";
import QpscCups from "./pages/QpscCups";
import QpscCupsDetail from "./pages/QpscCupsDetail";
import SeasonManagement from "./pages/SeasonManagement";
// Documenti legali (cantiere LEGAL-DOCS): contenitore, elenchi per categoria e
// documento, contenuto nel bundle.
import MorePage from "./pages/legal/MorePage";
import LegalIndex from "./pages/legal/LegalIndex";
import LegalDocument from "./pages/legal/LegalDocument";

// 1. PRIVATE ROUTE
//
// ⚠️ RL-6 — CODA 12 CHIUSA: non è più un cancello a sé.
//
// Com'era: «c'è un utente? allora entra». Chiedeva SOLO l'autenticazione, e
// dello `status` non sapeva nulla. Un utente ARCHIVED, che AuthContext tiene
// collegato di proposito (gli scrive `{firebaseUid, email, status:"ARCHIVED"}`
// per potergli mostrare la schermata giusta invece di sbatterlo fuori senza
// spiegazioni), risultava qui un utente come gli altri: bastava digitare
// /teams, /fees, /messaging o una qualunque delle venti rotte qui sotto per
// entrare nell'app dopo essere stati archiviati. La schermata «Account
// archived» esisteva già, ma la vedeva solo chi passava dalle rotte avvolte
// in RequireRole (/home e le home per ruolo).
//
// Com'è: PrivateRoute DELEGA al cancello condiviso, senza prop di ruolo —
// che in RequireRole significa esattamente «basta un utente attivo», cioè
// ciò che PrivateRoute ha sempre voluto dire. Non nasce un secondo gate: ne
// sparisce uno (contratto punto 5, «UNA sola funzione condivisa di gate»).
//
// ⚠️ CHE COSA CAMBIA DAVVERO per le rotte qui sotto, dichiarato per intero —
// sono tre controlli in più, tutti nel verso della chiusura, nessuno nel
// verso dell'apertura:
//   - ARCHIVED → schermata «Account archived» (il varco della coda 12);
//   - PENDING  → /home/pending, invece della pagina (contratto punto 3:
//                «un utente PENDING vede SOLO una schermata d'attesa»);
//   - scheda incompleta → /home/incomplete (il terzo binario di RL-6).
// E una differenza di resa, minima: durante l'attesa dell'autenticazione
// non compare più la scritta «Loading auth...», si vede una pagina vuota —
// è ciò che RequireRole fa già su tutte le altre rotte, e uniformarsi è il
// prezzo (accettato) di avere un cancello solo.
//
// Resta cortesia grafica, come ogni gate del frontend: la protezione vera è
// sul backend.
const PrivateRoute = ({ children }) => <RequireRole>{children}</RequireRole>;

// 2. PUBLIC ROUTE (login/register, accessibili solo se NON loggato)
//
// Non decide più dove mandare l'utente: manda all'instradatore /home,
// che è l'unico posto in cui si legge la mappa ruolo→rotta
// (src/auth/access.js). Così la mappa in tutta l'app resta una sola e
// l'atterraggio tiene conto anche di status PENDING/ARCHIVED e dei
// multi-ruolo, cosa che la vecchia mappa locale non faceva.
const PublicRoute = ({ children }) => {
  const { user, isReady } = useAuth();
  if (!isReady) return <div>Loading auth...</div>;
  if (!user) return children;

  return <Navigate to="/home" replace />;
};

// Wrapper separato per Routes che usa useAuth e il tuo hook
function AppRoutes() {
  // `user` serve al solo hook delle notifiche, qui sotto.
  // (`refreshUserFromBackend` non si destruttura più: la rilettura
  //  dell'utente collegato dopo un salvataggio su sé stessi la fa ora la
  //  pagina della scheda, che il contesto ce l'ha per conto suo — cantiere
  //  View Profile, fase 3.)
  const { user } = useAuth();
  // ⚠️ EFFETTO DI RIFLESSO DICHIARATO (P9). L'hook qui sotto dipende
  // dall'OGGETTO `user` (useFCMDeviceToken, `[user]`), e da P9 quell'oggetto
  // viene riscritto anche dopo che una persona ha salvato il proprio profilo
  // o i propri contexts, non più al solo ingresso. L'hook rigira quindi una
  // volta in più per ogni salvataggio, e conviene sapere che cosa fa quel
  // giro:
  //   - registra di nuovo il gestore `onMessage` di primo piano, che il
  //     cleanup dell'effetto aveva appena tolto: da P11-push la registrazione
  //     sta in cima alla funzione (useFCMDeviceToken.js) e non è più
  //     preceduta dai due `return` del blocco del token, che escono
  //     dall'intera funzione;
  //   - rilegge il token e NON rimanda nulla al backend, perché esce prima
  //     quando il token coincide con quello in `localStorage`
  //     (useFCMDeviceToken.js);
  //   - richiama `Notification.requestPermission()`: a permesso già concesso
  //     o già negato non mostra nulla, ma se la persona non ha mai risposto
  //     (permesso "default") IL POPUP DEL BROWSER RICOMPARE — a salvataggio
  //     appena fatto, che è un momento infelice per chiederlo.
  // Nessun ciclo: quel giro non tocca `user`.
  useFCMDeviceToken(user);

  // ===========================================================================
  // L'AVVISO IN-APP — l'ascoltatore che non c'era (Blocco 5, Fetta B)
  // ===========================================================================
  // Fino a qui l'arrivo di un messaggio, ad app aperta, spariva nel nulla. Non
  // per un errore di consegna: perché PARLAVA A NESSUNO. Il frontend aveva due
  // emettitori e ZERO ascoltatori —
  //   • l'hook `useFCMDeviceToken` emetteva l'evento DOM `qpsc-push`;
  //   • il service worker faceva `postMessage({ type: "QPSC_PUSH" })` alle
  //     schede aperte, e per farlo RINUNCIAVA alla notifica di sistema;
  // e in tutto `frontend/src` e `frontend/public` non esisteva un solo
  // `addEventListener` per nessuno dei due. Il worker cedeva la parola a un
  // interlocutore inesistente.
  //
  // Questo effetto ascolta ENTRAMBI i canali e li riduce a UNO: il messaggio
  // del service worker viene ritradotto nell'evento `qpsc-push`, così chi
  // domani vorrà consumare gli arrivi dovrà conoscere un canale solo.
  //
  // ⚠️ CHE COSA AGGIORNA, OGGI — detto per intero, perché è meno di quanto il
  // nome prometta.
  //   • Su /messaging non c'è NULLA da svegliare: il pallino dei non-letti
  //     (`nonLetti`) e i messaggi della conversazione arrivano da due
  //     `onSnapshot` di Firestore, cioè sono già vivi per conto loro. Il
  //     pallino cambia da sé all'arrivo del messaggio, push o non push.
  //   • FUORI da /messaging un indicatore NON ESISTE: il bottone «Live Chat»
  //     delle home non porta conteggio, e nel frontend non c'è alcun primitivo
  //     di «toast» o banner da riusare (cercato: zero riscontri). Inventarne
  //     uno qui sarebbe stato un sistema di notifiche in-app nuovo, fuori
  //     mandato.
  // Questo resta quindi il PUNTO UNICO in cui agganciare l'avviso in-app il
  // giorno in cui il badge globale verrà deciso: chi lo farà mette la sua
  // chiamata dentro `consuma`, e non deve toccare né l'hook né il worker.
  React.useEffect(() => {
    const consuma = (evento) => {
      const chatId = evento?.detail?.chatId || null;
      // La traccia sola: l'arrivo non passa più in silenzio assoluto.
      console.info("[push] messaggio in arrivo per la chat:", chatId || "(ignota)");
    };

    // Canale 1 — l'evento DOM emesso dall'hook (app in primo piano).
    window.addEventListener("qpsc-push", consuma);

    // Canale 2 — il messaggio del service worker (app non in primo piano),
    // ritradotto nel canale 1 invece di essere consumato a parte.
    const daWorker = (evento) => {
      if (evento?.data?.type !== "QPSC_PUSH") return;
      const payload = evento.data.payload || {};
      try {
        window.dispatchEvent(new CustomEvent("qpsc-push", {
          detail: {
            title: payload?.data?.titolo || "QPSC",
            body: payload?.data?.corpo || "",
            chatId: payload?.data?.chatId || null,
            payload
          }
        }));
      } catch (err) { /* un avviso mancato non deve rompere la pagina */ }
    };
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("message", daWorker);
    }

    return () => {
      window.removeEventListener("qpsc-push", consuma);
      if (navigator.serviceWorker) {
        navigator.serviceWorker.removeEventListener("message", daWorker);
      }
    };
  }, []);

  return (
    <Routes>
      {/* PUBLIC ROUTE */}
      <Route path="/login" element={
        <PublicRoute>
          <Login />
        </PublicRoute>
      } />
      {/* L'ISCRIZIONE sul modello nuovo, una rotta sola per entrambi i
          percorsi (RL-4 per l'adulto, RL-5a per la famiglia). La pagina
          comincia con la scelta fra «mi iscrivo io» (POST /enrol) e «iscrivo
          uno o più minori» (POST /enrol-family) e mostra il ramo scelto senza
          cambiare indirizzo: il percorso si sceglie DENTRO la pagina, e una
          seconda rotta non aggiungerebbe nulla se non un secondo indirizzo da
          tenere allineato. È dietro PublicRoute come /login: chi è già
          collegato non ha nulla da fare in un modulo d'iscrizione, e viene
          mandato all'instradatore /home.
          ⚠️ RL-5b HA TOLTO LE DUE ROTTE VECCHIE, /register e /register-multi,
          che stavano qui sotto come rete finché il percorso nuovo non fosse
          in piedi. Non sono state sostituite da un redirect: chi arriva con
          un vecchio collegamento cade nel catch-all di fondo file, come per
          qualunque altro indirizzo inesistente. Non se ne rimettano di
          nuove: la porta d'iscrizione è questa, e una sola.
          ⚠️ RL-6 le sostituisce con i due REDIRECT qui sotto — non sono
          rotte nuove e non montano nessun modulo vecchio (quei file non
          esistono più): sono un cartello che indica la porta nuova. */}
      <Route path="/enrol" element={
        <PublicRoute>
          <Enrol />
        </PublicRoute>
      } />
      {/* I due vecchi indirizzi d'iscrizione (RL-6, micro-ritocco a).
          Cadevano nel catch-all di fondo file, che manda a /home: chi
          arrivava da un vecchio segnalibro o da un link stampato finiva
          quindi al login, senza capire perché. Ora atterra dritto sulla
          porta nuova. Il redirect è verso /enrol e non verso il modulo:
          resta PublicRoute a decidere che cosa mostrargli, così chi è già
          collegato non finisce comunque in un modulo d'iscrizione.
          /register-multi c'è per la stessa ragione di /register — era una
          rotta pubblicizzata quanto l'altra — e costa una riga. */}
      <Route path="/register" element={<Navigate to="/enrol" replace />} />
      <Route path="/register-multi" element={<Navigate to="/enrol" replace />} />

      {/* PRIVATE ROUTE */}
      {/* Instradatore: stessi controlli globali delle home, perché usa
          lo stesso cancello condiviso.
          ⚠️ `router` (P2, 24/9/2026): è l'UNICA rotta senza ruolo aperta a
          chi è SOLO GUEST — non è una pagina, è il bivio che lo porta su
          /home/guest. Ogni altra rotta senza ruolo (PrivateRoute compresa)
          gli risponde «Access not allowed»: v. RequireRole.jsx, passo 6. */}
      <Route path="/home" element={
        <RequireRole router>
          <Home />
        </RequireRole>
      } />
      {/* La rotta /dashboard è stata RITIRATA in P2 (8/8/2026). Era una
          seconda anagrafica del club, con otto card che rispondevano alle
          stesse domande di /users con calcoli diversi e una tabella dei
          pagamenti gemella. Nessun menù, link o redirect la raggiungeva:
          si arrivava solo digitando l'URL. Era protetta dalla sola
          autenticazione (PrivateRoute), mentre /users qui sotto è chiusa
          ad ADMIN e SUPERADMIN dal cantiere U1-S: ritirandola cade anche
          quell'asimmetria. Le card vivono ora solo in UsersList. */}
      {/* Anagrafica completa del club: riservata ad ADMIN e SUPERADMIN.
          Prima bastava essere autenticati, quindi la apriva chiunque
          avesse fatto login — cantiere U1-S. Respinto = niente lista e
          nessun dato caricato: il gate avvolge la pagina, non la decora.
          I due ruoli si elencano entrambi perché il gate unico non ha
          gerarchia (vedi RequireRole).
          Resta cortesia grafica, come ogni gate del frontend: la
          protezione vera è che GET /users, senza parametri, è ormai
          riservata ad ADMIN e SUPERADMIN sul backend (punto 2 del
          cantiere) e risponde 403 a chiunque altro, token o no. */}
      <Route path="/users" element={
        <RequireRole role={["ADMIN", "SUPERADMIN"]}>
          <UsersList />
        </RequireRole>
      } />
      {/* Assegnazione delle squadre: riservata ad ADMIN e SUPERADMIN
          (cantiere SICUREZZA, G1-c). Era dietro `PrivateRoute`, cioè
          `RequireRole` SENZA `role`: bastava aver fatto login — un
          giocatore, un genitore — per aprire la pagina che sposta i
          tesserati fra le squadre di tutto il club. Si copia la riga di
          /users qui sopra, e i due ruoli si elencano entrambi perché il
          gate unico non ha gerarchia (vedi RequireRole).
          Resta CORTESIA GRAFICA, come ogni gate del frontend: la difesa
          vera delle squadre è sul backend, dove le rotte di scrittura
          (POST /teams, PUT /teams/:id, PUT /teams/rename, DELETE
          /teams/:name) sono già riservate ad ADMIN e SUPERADMIN. Qui si
          allinea la porta al suo uso. */}
      <Route path="/teams" element={
        <RequireRole role={["ADMIN", "SUPERADMIN"]}>
          <TeamAssignment />
        </RequireRole>
      } />
      {/* TEAMS (cantiere TEAMS-LIST, E1): elenco delle squadre dell'annata
          e dettaglio di una squadra, SOLA CONSULTAZIONE. `/teams` è di Team
          Assignment: qui un indirizzo proprio. Stesso gate di /teams. */}
      <Route path="/teams-list" element={
        <RequireRole role={["ADMIN", "SUPERADMIN"]}>
          <TeamsList />
        </RequireRole>
      } />
      <Route path="/teams-list/:season/:team" element={
        <RequireRole role={["ADMIN", "SUPERADMIN"]}>
          <TeamsListDetail />
        </RequireRole>
      } />
      {/* MEMBER REMINDERS (Fase 1): solleciti ai soci spediti a mano, oggi il
          solo «Complete your data». Stesso gate di /users. Resta cortesia
          grafica: la difesa vera è POST /reminders/complete-data, riservata
          ad ADMIN e SUPERADMIN sul backend, e GET /users, già loro. */}
      <Route path="/reminders" element={
        <RequireRole role={["ADMIN", "SUPERADMIN"]}>
          <Reminders />
        </RequireRole>
      } />
      {/* ⚠️ IL QUARTO GATE (UNIFORMS/D5). Era dietro `PrivateRoute`, cioè
          `RequireRole` SENZA `role`: bastava essere autenticati — un
          giocatore, un genitore — per aprire la distribuzione delle divise di
          tutto il club, e da lì la modale di configurazione, che rotta propria
          non ha. Le tre rotte del backend sono ora riservate ad ADMIN e
          SUPERADMIN (Fetta A) e rispondono 403 a chiunque altro: qui si
          allinea la cortesia grafica alla protezione vera, con la stessa forma
          di `/users` qui sopra. */}
      <Route path="/uniforms" element={
        <RequireRole role={["ADMIN", "SUPERADMIN"]}>
          <UniformDistribution />
        </RequireRole>
      } />
      {/* CLINIC / OFF SEASON / SPECIALS — la plancia degli eventi clinic
          (cantiere CLINICS, Fetta B, 15/9/2026).
          Gate ADMIN/SUPERADMIN nella stessa forma di /users, /teams e
          /uniforms qui sopra: i due ruoli si elencano entrambi perché il
          gate unico non ha gerarchia (vedi RequireRole).
          Resta CORTESIA GRAFICA, come ogni gate del frontend: la protezione
          vera è che tutte le rotte /clinic-events* del backend sono riservate
          ad ADMIN e SUPERADMIN e rispondono 403 a chiunque altro, token o no,
          e che la collezione `clinicEvents` ricade nel default-deny delle
          regole Firestore — dal browser non è raggiungibile affatto.
          ⚠️ ROTTA NUOVA, e NON è /admin/clinics: quella era la vecchia
          sezione clinics, il cui codice è stato tolto dalla P3 (24/9/2026);
          il suo indirizzo finisce oggi nel catch-all di fondo file.
          Ci si arriva dalla voce «Clinic / Off Season / Specials» delle
          home HomeAdmin e HomeSuperadmin. */}
      <Route path="/clinic-events" element={
        <RequireRole role={["ADMIN", "SUPERADMIN"]}>
          <ClinicEvents />
        </RequireRole>
      } />
      {/* LA PAGINA DI UN EVENTO CLINIC (CLINICS, Fetta 3 «plancia a pagine»,
          23/9/2026): ci si arriva dal clic su una riga di /clinic-events, e
          il suo Back riporta sempre lì. Stesso gate di /clinic-events, qui
          sopra, copiato riga per riga; la protezione vera resta sulle rotte
          /clinic-events* del backend. Non collide con /clinic-events: in
          react-router 6 il confronto è sull'intero percorso. */}
      <Route path="/clinic-events/:id" element={
        <RequireRole role={["ADMIN", "SUPERADMIN"]}>
          <ClinicEventDetail />
        </RequireRole>
      } />
      {/* COACH ATTENDANCE — le presenze degli allenatori, segnate
          dall'amministratore (cantiere COACH-ATTENDANCE, Fetta 2, 16/9/2026).
          Gate ADMIN/SUPERADMIN nella stessa forma di /users qui sopra: i due
          ruoli si elencano entrambi perché il gate unico non ha gerarchia
          (vedi RequireRole).
          Resta CORTESIA GRAFICA, come ogni gate del frontend: la protezione
          vera sono le tre rotte /coach-attendance* del backend (Fetta 1),
          riservate ad ADMIN e SUPERADMIN, che rispondono 403 a chiunque
          altro, token o no. */}
      <Route path="/coach-attendance" element={
        <RequireRole role={["ADMIN", "SUPERADMIN"]}>
          <CoachAttendance />
        </RequireRole>
      } />
      {/* LA SCHEDA DI UN ALLENATORE (Fetta 3, 16/9/2026): sola lettura, ci
          si arriva dal nome nella pagina qui sopra. Stesso gate, copiato
          riga per riga: i due ruoli si elencano entrambi perché il gate
          unico non ha gerarchia. Non collide con /coach-attendance: in
          react-router 6 il confronto è sull'intero percorso e la scelta va
          per specificità (v. /attendance e /attendance/child/:childId).
          Cortesia grafica anche qui: la protezione vera è
          GET /coach-attendance/coach/:coachId del backend (Fetta 1), e
          GET /users/:id, che risponde per la matrice. */}
      <Route path="/coach-attendance/coach/:coachId" element={
        <RequireRole role={["ADMIN", "SUPERADMIN"]}>
          <CoachAttendanceDetail />
        </RequireRole>
      } />
      {/* CLINIC SESSIONS — l'area del SOCIO (cantiere CLINICS, Fetta C2,
          15/9/2026): gli eventi aperti, e l'iscrizione di un proprio figlio
          minore. Ci si arriva dal bottone «Clinic / Off Season / Specials»
          delle home HomePlayer, HomeChild e HomeCoach.
          ⚠️ L'ELENCO DEI RUOLI È LO STESSO DI /more, più sotto. Il GUEST
          resta FUORI da questa rotta — non perché una riga lo nomini, ma
          perché è assente da ogni elenco di ruoli ammessi (DISEGNO §7, il
          pattern FAN/ESPORT): lo stesso componente gli arriva da
          /home/guest (HomeGuest).
          Resta cortesia grafica: la protezione vera è che le rotte
          /clinic-member/* del backend hanno lo stesso elenco di ruoli, e che
          l'iscrizione vera la decide la TUTELA sul figlio
          (eProprietarioOTutore), non il ruolo. */}
      <Route path="/clinics" element={
        <RequireRole role={["ADMIN", "SUPERADMIN", "PLAYER", "PARENT", "COACH"]}>
          <ClinicMember />
        </RequireRole>
      } />
      {/* IL CALENDARIO CLINIC DI UNA PERSONA (CALENDARIO CLINIC, Fetta 2,
          23/9/2026): la settimana di sé stessi o di un figlio, con l'id
          nell'indirizzo come /my-calendar/child/:childId. Stesso elenco di
          ruoli di /clinics, qui sopra, PIÙ il GUEST (Fetta G2, 24/9/2026): la
          sua pagina delle clinic è /home/guest, e da lì il «Calendar» porta
          qui; «Back» torna indietro di un passo, cioè alla sua home. Resta
          cortesia grafica: chi può vedere QUALE persona lo decide
          GET /clinic-member/calendar/:personId sul server (sé stessi, o tutore
          registrato in `guardians` del figlio). */}
      <Route path="/clinics/calendar/:personId" element={
        <RequireRole role={["ADMIN", "SUPERADMIN", "PLAYER", "PARENT", "COACH", "GUEST"]}>
          <ClinicCalendar />
        </RequireRole>
      } />
      {/* LA BACHECA DEL GRUPPO, «BOARD - CHAT» (Fetta A, 26/9/2026): la
          bacheca del gruppo di una persona in un evento, dal bottone delle
          righe ENROLLED di /clinics (e di /home/guest). Stesso elenco di ruoli
          del calendario, GUEST compreso. Resta cortesia grafica: chi legge e
          chi scrive lo decide GET/POST /clinic-member/board/:eventId/:personId
          sul server (sé stessi, o tutore registrato in `guardians`). */}
      <Route path="/clinics/board/:eventId/:personId" element={
        <RequireRole role={["ADMIN", "SUPERADMIN", "PLAYER", "PARENT", "COACH", "GUEST"]}>
          <ClinicBoard />
        </RequireRole>
      } />
      {/* Cassa del club: SUPERADMIN e nessun altro.
          Fino a oggi era su `PrivateRoute`, che è `RequireRole` senza `role`,
          cioè «basta un utente attivo»: qualunque socio — un PLAYER, anche
          minorenne, o un PARENT — digitando l'indirizzo vedeva saldi,
          movimenti, fornitori e importi (audit 14 §3.2).
          Il cancello è quello unico (RequireRole + access.js), nella stessa
          forma delle home per ruolo qui sotto: nessun gate nuovo.
          Resta cortesia grafica: la protezione vera è sulle rotte del
          backend (server.js, blocchi TRANSACTIONS/CATEGORIES/CONTACTS). */}
      <Route path="/finance" element={
        <RequireRole role="SUPERADMIN">
          <ClubFinance />
        </RequireRole>
      } />
      <Route path="/season-management" element={
        <RequireRole role="SUPERADMIN">
          <SeasonManagement />
        </RequireRole>
      } />
      {/* Documenti legali (cantiere LEGAL-DOCS): il contenitore «More /
          Assistance» (/more), i due elenchi per categoria — «Legal & Privacy»
          (/legal) e «Terms & Conditions» (/terms), lo stesso LegalIndex con
          categoria e titolo diversi — e il singolo documento (/legal/:slug,
          visualizzatore unico: lo slug è unico fra tutte le categorie).
          Aperti a tutte le home che portano la voce «More / Assistance»:
          ADMIN, SUPERADMIN, PLAYER, PARENT e COACH — i ruoli si elencano tutti
          perché il gate unico non ha gerarchia (vedi RequireRole), e l'elenco
          è identico sulle quattro rotte perché /legal/:slug serve i documenti
          di ogni categoria. Nessuna rotta backend: il contenuto vive nel
          bundle, e il gate è cortesia di navigazione, non riservatezza. */}
      <Route path="/more" element={
        <RequireRole role={["ADMIN", "SUPERADMIN", "PLAYER", "PARENT", "COACH"]}>
          <MorePage />
        </RequireRole>
      } />
      <Route path="/legal" element={
        <RequireRole role={["ADMIN", "SUPERADMIN", "PLAYER", "PARENT", "COACH"]}>
          <LegalIndex category="legal" title="Legal & Privacy" />
        </RequireRole>
      } />
      <Route path="/terms" element={
        <RequireRole role={["ADMIN", "SUPERADMIN", "PLAYER", "PARENT", "COACH"]}>
          <LegalIndex category="terms" title="Terms & Conditions" />
        </RequireRole>
      } />
      <Route path="/legal/:slug" element={
        <RequireRole role={["ADMIN", "SUPERADMIN", "PLAYER", "PARENT", "COACH"]}>
          <LegalDocument />
        </RequireRole>
      } />
      <Route path="/calendar" element={
        <PrivateRoute>
          <CalendarClub />
        </PrivateRoute>
      } />

      {/* CALENDARIO DEL SOCIO (doc 07 §13) — pagina NUOVA, su rotta
          propria, in SOLA LETTURA: la settimana della propria squadra,
          vestita col telaio comune. Non sostituisce /calendar qui sopra,
          che resta la pagina dell'ADMIN (tabella di club, «Select teams»,
          Weekly Planner, «+ Add Event»): le due COESISTONO, ed è uno stato
          transitorio voluto dal committente.
          ⚠️ LE VOCI DELLE HOME, oggi: HomePlayer → /my-calendar, HomeChild
          → /my-calendar/child/:childId, HomeCoach →
          /my-calendar/team/<squadra> (le due rotte con parametro qui sotto);
          solo HomeAdmin e HomeSuperadmin puntano a /calendar, ed è voluto.
          STESSO CANCELLO di /calendar, copiato di peso: <PrivateRoute>,
          cioè RequireRole senza prop di ruolo — «basta un utente attivo».
          Nessun ruolo richiesto, perché la pagina serve PLAYER, COACH e il
          genitore in delega, e non concede nessuna scrittura: il gate dei
          comandi sta sul backend (fetta A: POST/PUT/DELETE su /events
          chiedono ADMIN). */}
      <Route path="/my-calendar" element={
        <PrivateRoute>
          <MyCalendar />
        </PrivateRoute>
      } />

      {/* LE DUE ROTTE CON PARAMETRO — la stessa pagina, con detto DI CHI è
          la settimana che si guarda. Servono perché la squadra da mostrare
          non sta sempre sull'utente collegato:
            `/my-calendar/team/:teamName`  la squadra che l'allenatore ha
              aperto nella sua home. `squadraScelta` è stato INTERNO di
              HomeCoach e senza questo parametro non usciva di lì: il
              calendario mostrava l'UNIONE di tutte le sue squadre;
            `/my-calendar/child/:childId`  il figlio che il genitore sta
              guardando. È lo STESSO parametro di `/home/child/:childId`,
              da cui si arriva.
          DUE FORME SEPARATE e non un parametro solo: un nome di squadra e
          un id non si distinguono a occhio, e indovinare quale sia l'uno o
          l'altro sarebbe un'invenzione.
          I tre segmenti non collidono con `/my-calendar` — react-router 6
          sceglie il percorso più specifico, è la stessa convivenza di
          `/profile/:id` con `/profile/:id/edit` — e `/my-calendar` nudo
          resta la via di chi non porta parametri (il giocatore) e il
          ripiego di chi ci arriva per indirizzo digitato o segnalibro.
          ⚠️ L'INVOLUCRO È LO STESSO delle altre due — `<PrivateRoute>`,
          nessun ruolo — e deve restarlo: la tutela del minore NON è qui e
          non può esserlo. Sta sul backend, nel ramo tutore di
          `GET /users/:id` (server.js), che a chi non è tutore né
          amministratore né allenatore del tesserato risponde 403. La
          pagina, in quel caso, non mostra nulla del minore. */}
      <Route path="/my-calendar/team/:teamName" element={
        <PrivateRoute>
          <MyCalendar />
        </PrivateRoute>
      } />
      <Route path="/my-calendar/child/:childId" element={
        <PrivateRoute>
          <MyCalendar />
        </PrivateRoute>
      } />
      <Route path="/messaging" element={
        <PrivateRoute>
          <Messaging />
        </PrivateRoute>
      } />
      {/* L'ASSISTENTE AI PER I SOCI (cantiere ASSISTENTE-SOCI).
          ⚠️ <PrivateRoute> NUDO, non <RequireRole role={...}>: basta un socio
          attivo. Il muro «solo soci» non è di ruolo, è di CONTENUTO — la guida
          iniettata è già potata della materia da funzionario (Decisione 3),
          quindi un Admin che digitasse l'indirizzo non troverebbe nulla di
          riservato. Il login serve perché la chiamata al backend porta il token.
          Sta accanto a /messaging per leggibilità: React Router 6 sceglie per
          specificità, non per ordine, quindi la posizione non è un puntello. */}
      <Route path="/assistant" element={
        <PrivateRoute>
          <Assistant />
        </PrivateRoute>
      } />
      <Route path="/permissions" element={
        <PrivateRoute>
          <PermissionsManager />
        </PrivateRoute>
      } />

      {/* PRESENZE — LO STESSO SCHEMA DI /my-calendar, e per le stesse
          ragioni (cantiere ATTENDANCE, fetta F2).
            `/attendance`                    la FORMA NUDA: la pagina del
              giocatore, che la squadra se la ricava dalle proprie tessere
              (lettore unico), come /my-calendar nudo;
            `/attendance/team/:teamName`     la squadra che l'allenatore ha
              aperto nella sua home. `squadraScelta` è stato INTERNO di
              HomeCoach e senza questo parametro non uscirebbe di lì.
            `/attendance/child/:childId`     il figlio che il genitore sta
              guardando (fetta F3). È lo STESSO parametro di
              `/home/child/:childId` e di `/my-calendar/child/:childId`, da
              cui si arriva, e la pagina ne carica il DOCUMENTO per
              prenderne la squadra: il figlio viaggia nell'indirizzo, mai
              in `localStorage` e mai in `location.state`.
          ⚠️ L'INVOLUCRO È LO STESSO delle altre pagine del socio —
          <PrivateRoute>, cioè RequireRole SENZA prop di ruolo: «basta un
          utente attivo» — e deve restarlo. La tutela NON è qui e non può
          esserlo: sta sul GATE DELLA PAGINA (che respinge chi non indossa
          il cappello giusto prima di ogni chiamata) e soprattutto sul
          BACKEND, dove `POST /attendance`, `GET /attendance/player/:uid` e
          `GET /attendance/team/:teamName` verificano da sé chi chiede e
          che cosa (fetta F1). Un vincolo di ruolo scritto qui darebbe
          l'illusione di una difesa che vive altrove. */}
      <Route path="/attendance" element={
        <PrivateRoute>
          <Attendance />
        </PrivateRoute>
      } />

      <Route path="/attendance/team/:teamName" element={
        <PrivateRoute>
          <AttendanceSummary />
        </PrivateRoute>
      } />

      {/* ⚠️ NESSUN VINCOLO DI RUOLO, come sulle altre due e come sulla
          gemella `/my-calendar/child/:childId`: il genitore non indossa il
          cappello PLAYER, e chiederglielo qui chiuderebbe fuori proprio
          lui. La tutela è sul BACKEND — `GET /users/:id`, `GET
          /attendance/player/:uid` e `POST /attendance` rispondono 403 a
          chi non è tutore del soggetto (`guardians` sul documento del
          figlio) — e la pagina, in quel caso, non mostra nulla del
          minore. */}
      <Route path="/attendance/child/:childId" element={
        <PrivateRoute>
          <Attendance />
        </PrivateRoute>
      } />

      {/* GAMES — LA SEZIONE PARTITE DEL COACH (cantiere GAMES, fette G1 e G2).
            `/games/team/:teamName`                    la lista partite della
              squadra aperta nella home del coach;
            `/games/team/:teamName/prepare/:eventId`   la pagina di una
              partita di quella squadra, in quattro fasi: convocazione,
              campo dal vivo, chiusura, riepilogo.
          La squadra viaggia NEL PARAMETRO DI ROTTA, come per
          `/attendance/team/:teamName` e `/my-calendar/team/:teamName`: è
          la sola strada che sopravvive al ricaricamento.
          ⚠️ L'INVOLUCRO È `<PrivateRoute>`, cioè RequireRole SENZA ruolo —
          lo stesso delle altre pagine di squadra del coach — e deve
          restarlo: la tutela NON è qui. Sta sul GATE DELLA PAGINA (il
          componente esterno respinge chi non indossa il cappello COACH
          prima di ogni chiamata) e soprattutto sul BACKEND, dove
          `GET /games/team/:teamName` e `GET /attendance/team/:teamName`
          ammettono i soli coach di quella squadra nell'anno operativo. Un
          vincolo di ruolo scritto qui darebbe l'illusione di una difesa
          che vive altrove. */}
      <Route path="/games/team/:teamName" element={
        <PrivateRoute>
          <GamesListPage />
        </PrivateRoute>
      } />

      <Route path="/games/team/:teamName/prepare/:eventId" element={
        <PrivateRoute>
          <GamePreparePage />
        </PrivateRoute>
      } />

      {/* LA SCHEDA DEL TESSERATO — DUE ROTTE, UNA SOLA PAGINA
          (cantiere View Profile, fase 3 — doc 07 §11.1).

          Fino a ieri la scheda era un riquadro sovrapposto, montato da
          cinque punti diversi con prop diverse; da oggi è una PAGINA con
          un indirizzo suo, e i cinque punti ci NAVIGANO.

          ⚠️ `/profile/:id` — l'indirizzo della scheda di CHIUNQUE. La
          guardia è la sola autenticazione, come per la vista delegata del
          minore: la protezione del dato NON è qui e non può esserlo, sta
          sul backend, nella matrice dei permessi di `GET /users/:id` (sé
          stessi / tutore / admin / coach della squadra), che a tutti gli
          altri risponde 403. Ora che le schede hanno un indirizzo il caso
          è raggiungibile a mano: la pagina lo rende con la sua riga unica
          — «This profile is not available.» — e il «Back» della banda.

          ⚠️ `/myprofile` RESTA, e resta una rotta vera, non un rimando:
          la linkano «My Profile» di HomeParent e di HomePlayer,
          e vecchi segnalibri. Non porta id: la pagina, non
          trovandolo nella rotta, mostra l'utente collegato. Cadono tutte
          e quattro le prop di prima — l'id, la chiusura, `onDelete` e
          `onUpdate`: la rilettura dell'utente collegato dopo un salvataggio
          su sé stessi (P9, voce 4) la fa ora la pagina, che chiama
          `refreshUserFromBackend` da sé quando la scheda aperta è la
          propria. */}
      <Route path="/profile/:id" element={
        <PrivateRoute>
          <MemberProfileModal />
        </PrivateRoute>
      } />

      <Route path="/myprofile" element={
        <PrivateRoute>
          <MemberProfileModal />
        </PrivateRoute>
      } />

      {/* LA MODIFICA DELLA SCHEDA — anch'essa una PAGINA
          (cantiere «Edit Member», fase 1 — doc 07 §12,
          `docs/cantieri/EDIT-MEMBER-SPEC.md` §1).

          Era un riquadro sovrapposto aperto dal pulsante «Edit Member» della
          scheda; da oggi ha un indirizzo suo, e quel pulsante ci NAVIGA.

          ⚠️ TRE SEGMENTI, e non collide con `/profile/:id`: in react-router 6
          il confronto è sull'intero percorso, quindi la rotta a due segmenti
          non intercetta questa. Per la stessa ragione non serve riordinare
          nulla, e il catch-all di fondo file non la ruba (v6 sceglie per
          specificità, non per ordine).

          ⚠️ L'involucro è lo STESSO di `/profile/:id` — `PrivateRoute`, cioè
          «basta un utente attivo» — e NON `RequireRole role="ADMIN"`: il
          riservare la pagina agli amministratori è dentro la pagina, che a
          chiunque altro mostra la sua riga unica DENTRO il telaio, con la
          barra utente e il «Back». Il rimbalzo del cancello condiviso
          porterebbe invece a una schermata d'errore che perde il ritorno alla
          scheda. La protezione del dato, come sempre, sta sul backend: è
          `PUT /users/:id` a rifiutare con 403 chi non ha titolo. */}
      <Route path="/profile/:id/edit" element={
        <PrivateRoute>
          <EditMemberPage />
        </PrivateRoute>
      } />

      {/* LE CINQUE HOME DEL MODELLO NUOVO
          Ognuna è avvolta dal cancello condiviso con il ruolo che
          richiede: le pagine non contengono più logica d'accesso. Le
          rotte vecchie (/home/homesuperadmin, /home/homeadmin,
          /home/homemanager, /home/homeplayer, /home/homeparent,
          /home/homefan, /home/homeesport, /home/hometd,
          /home/homemanagertd) sono abbandonate — diario, decisione A. */}
      <Route path="/home/superadmin" element={<RequireRole role="SUPERADMIN"><HomeSuperadmin /></RequireRole>} />
      <Route path="/home/admin" element={<RequireRole role="ADMIN"><HomeAdmin /></RequireRole>} />
      <Route path="/home/coach" element={<RequireRole role="COACH"><HomeCoach /></RequireRole>} />
      <Route path="/home/player" element={<RequireRole role="PLAYER"><HomePlayer /></RequireRole>} />
      <Route path="/home/parent" element={<RequireRole role="PARENT"><HomeParent /></RequireRole>} />

      {/* HOME DI SOLA CLINIC — il ruolo GUEST (cantiere CLINICS, fetta A,
          12/9/2026; DISEGNO v2 §7). Sta fuori dalle cinque qui sopra
          perché il GUEST non è un socio: è il tutore autenticato del
          mondo clinic, senza tessera di stagione e senza alcun potere.
          La forma è però la STESSA delle altre — il cancello condiviso
          col ruolo richiesto — perché la sicurezza non si inventa: GUEST
          è riconosciuto solo qui, e resta fuori da ogni whitelist di
          permesso (vedi il cappello di ROLE_ROUTES in auth/access.js).
          Il passo 5 del cancello (il completamento da socio) non cambia
          per nessuno: un GUEST senza tessere semplicemente non lo
          attiva. La pagina monta la stessa ClinicMember di /clinics. */}
      <Route path="/home/guest" element={<RequireRole role="GUEST"><HomeGuest /></RequireRole>} />

      {/* Vista d'attesa: riservata a chi ha status PENDING. */}
      <Route path="/home/pending" element={<RequireRole status="PENDING"><HomePending /></RequireRole>} />

      {/* Vista «completa i tuoi dati» (RL-6, il terzo binario): riservata a
          chi è ACTIVE ma ha il marcatore `enrolled` spento. Non è un
          ingresso pubblico e non si raggiunge da nessun menù: ci arriva
          solo chi il cancello ci manda, e chi ha la scheda a posto viene
          rimandato all'instradatore. Il modulo vero è RL-7. */}
      <Route path="/home/incomplete" element={<RequireRole enrolment="INCOMPLETE"><HomeIncomplete /></RequireRole>} />

      {/* VISTA DELEGATA DEL MINORE (cantiere HOME-CHILD). Non è una home di
          ruolo — il figlio è un PLAYER con `isMinor`, non un ruolo — quindi
          NON sta nella mappa ruolo→rotta e non ha un `RequireRole`: ci si
          arriva dalla tessera del figlio nella home del genitore, e l'id
          del figlio viaggia nella rotta.
          La guardia è `PrivateRoute`, cioè la sola autenticazione: la
          protezione dei dati NON è qui e non può esserlo: sta sul backend,
          nel ramo tutore di `GET /users/:id`, che a chi non è tutore
          risponde 403. La pagina, in quel caso, non mostra nulla del
          minore. */}
      <Route path="/home/child/:childId" element={<PrivateRoute><HomeChild /></PrivateRoute>} />

      {/* La rotta vecchia della vista delegata non ha più una pagina: senza
          id non c'è nessun figlio da mostrare, e il meccanismo che la
          reggeva (la copia in `localStorage`) è stato demolito insieme
          alla pagina. Chi ci arriva — un segnalibro, un vecchio link
          interno — finisce all'instradatore, che lo rimanda alla home che
          gli spetta. Nessuna schermata di errore, nessun vicolo cieco. */}
      <Route path="/home/homechild" element={<Navigate to="/home" replace />} />

      {/* QPSC Cups — All Time: riservata ad ADMIN e SUPERADMIN (cantiere
          SICUREZZA, G1-d). Era dietro `PrivateRoute`, cioè `RequireRole`
          SENZA `role`: bastava aver fatto login. Si copia la riga di
          /teams qui sopra, e i due ruoli si elencano entrambi perché il
          gate unico non ha gerarchia (vedi RequireRole).
          La soglia è quella dell'uso reale: nessuna home ha più un
          pulsante verso /qpsc-cups (quello che c'era in HomeAdmin.jsx e
          HomeSuperadmin.jsx è stato tolto), la rotta si raggiunge solo
          per URL — nessun coach, nessun socio ci arriva da un menù — ed è
          la stessa soglia del backend, dove POST /cups/recalculate è già
          riservata ad ADMIN e SUPERADMIN (server.js, `requireRole("ADMIN",
          "SUPERADMIN")`). Oggi lo sono anche le due letture, GET /cups e
          GET /cups/:playerId (server.js, `requireRole("ADMIN",
          "SUPERADMIN")`): qui, come sempre, si allinea la CORTESIA GRAFICA
          all'uso, la difesa vera è sul backend.
          ⚠️ SEGNALATA, NON TOCCATA: la gemella `/qpsc-cups/:playerId` qui
          sotto resta su `PrivateRoute` perché l'incarico G1-d nomina due
          rotte sole. La pagina si apre a ogni socio autenticato, ma i DATI
          della scheda del singolo no: GET /cups/:playerId risponde 403 a
          chi non è ADMIN o SUPERADMIN. */}
      <Route path="/qpsc-cups" element={
        <RequireRole role={["ADMIN", "SUPERADMIN"]}>
          <QpscCups />
        </RequireRole>
      } />

      <Route path="/qpsc-cups/:playerId" element={
        <PrivateRoute>
          <QpscCupsDetail />
        </PrivateRoute>
      } />

      <Route
        path="/user-context-manager"
        element={
          <PrivateRoute>
            <UserContextManager />
          </PrivateRoute>
        }
      />
      
      {/* Finestra di scelta del ruolo: non chiede un ruolo preciso,
          solo un utente attivo. */}
      <Route
        path="/home/context"
        element={
          <RequireRole>
            <HomeContext />
          </RequireRole>
        }
      />
        
      {/* CALENDARIO DI CLUB — stesso cancello di /calendar (qui sopra),
          copiato di peso: <PrivateRoute>, cioè RequireRole senza prop di
          ruolo, che significa «basta un utente attivo». Era una rotta NUDA,
          e non per scelta: un anonimo ci atterrava e vedeva una pagina vuota
          invece del login, un ARCHIVED o un PENDING entravano nel calendario
          di club scavalcando la propria schermata. Nessun ruolo richiesto,
          esattamente come /calendar: è lettura per ogni socio. */}
      <Route path="/outlook" element={
        <PrivateRoute>
          <Outlook />
        </PrivateRoute>
      } />


      {/* RITORNO DEL LINK DI ACCESSO (RL-8b) — ROTTA NUDA, DI PROPOSITO.
          Ci si atterra cliccando il link ricevuto per email, e l'indirizzo
          porta con sé in query string `mode=signIn` e `oobCode=…`: è il
          codice d'accesso, e va consegnato INTATTO a FinishLogin.
          ⚠️ NIENTE PublicRoute, a differenza di /login e /enrol: PublicRoute
          manda a /home chi ha già una sessione, e quel <Navigate> riscrive
          l'indirizzo scartando la query string — cioè butterebbe via il
          codice proprio a chi sta rientrando da una sessione ancora viva.
          ⚠️ STA QUI, PRIMA del redirect radice e del catch-all di fondo
          file: quei due sono <Navigate to="/home">, e se intercettassero
          /finish-login il codice sparirebbe allo stesso modo. React Router 6
          sceglie per specificità e non per ordine, quindi il catch-all non
          vincerebbe comunque su un percorso letterale: la posizione è
          leggibilità, non un puntello.
          La query string non è materia di instradamento e non viene toccata
          da nessuno dei due: FinishLogin la ritrova per intero in
          `window.location.href`, che è dove Firebase la cerca. */}
      <Route path="/finish-login" element={<FinishLogin />} />

      {/* LA PORTA DEL GUEST — /clinic/:slug (cantiere CLINICS, Fetta C1,
          15/9/2026; DISEGNO v2 §4, §7). È il link pubblico di un evento
          clinic, distribuito dall'admin: da qui un tutore esterno al club
          iscrive un minore e riceve per email il link d'accesso, con cui
          entra da /finish-login e atterra su /home/guest.
          ⚠️ NUDA, come /finish-login e per la stessa ragione: PublicRoute
          manderebbe a /home chi ha una sessione viva, perdendo lo slug.
          ⚠️ Lo slug è OPACO e coniato dal server; il modulo mostra l'evento
          solo se il server lo dà per aperto, e il server rilegge lo stato a
          ogni invio (la leva apri/chiudi della plancia spegne il link).
          ⚠️ NON è /clinic-events, la plancia admin; né /admin/clinics o
          /clinic-register/:clinicId, gli indirizzi della vecchia sezione
          clinics, il cui codice è stato tolto dalla P3 (24/9/2026): oggi
          finiscono nel catch-all qui sotto, come ogni indirizzo sconosciuto. */}
      <Route path="/clinic/:slug" element={<ClinicGuestEnrol />} />

      {/* Redirect root */}
      <Route path="/" element={<Navigate to="/home" replace />} />
      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
}

const App = () => (
  <AuthProvider>
    <Router>
      <AppRoutes />
    </Router>
  </AuthProvider>
);

export default App;